import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {CLRoute} from 'common/src/modules/routing/routing.types';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {
  CreativeTemplatesManagerAgentToolName,
  TemplateStep,
} from '../creativeTemplatesManagetAgent.enums';

function navigateToCreativeTemplateHomeOrSetOrTearsheetTabTool() {
  const inputSchema = z.object({
    step: z.enum([TemplateStep.Home, TemplateStep.Set, TemplateStep.TearsheetList]),
    templateId: z.number(),
  });

  async function execute({
    input: {step, templateId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const urls: Record<TemplateStep.Home | TemplateStep.Set | TemplateStep.TearsheetList, CLRoute> =
      {
        [TemplateStep.Home]: Routes.TemplateWorkflow,
        [TemplateStep.Set]: Routes.TemplateWorkflowSet,
        [TemplateStep.TearsheetList]: Routes.TemplateWorkflowTearsheetList,
      };

    routingService.goTo({
      url: urls[step],
      pathParams: {templateId},
      queryParams: {},
    });

    return toolResult(`Navigated to creative template ${step} page`);
  }

  return tool({
    name: CreativeTemplatesManagerAgentToolName.NavigateToCreativeTemplateHomeOrSetOrTearsheetTab,
    description: 'Navigate to creative template workflow step (Home, Set, or Tearsheet)',
    displayName: 'Navigating',
    execute,
    inputSchema,
  });
}

export default navigateToCreativeTemplateHomeOrSetOrTearsheetTabTool;
